import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Accordion.css';

import AccordionSection from './AccordionSection';

/*
    props: 
        allowMultipleOpen - boolean to allow multiple accordions open
        children - an array-like children nodes with label prop for each node
        opened - boolean to set each accordion opened as default
*/

export default class Accordion extends Component {
  static propTypes = {
    allowMultipleOpen: PropTypes.bool,
    children: PropTypes.instanceOf(Object).isRequired,
    opened: PropTypes.bool,
    iconLeft: PropTypes.bool,
    iconOpened: PropTypes.string,
    hoverOpened: PropTypes.string,
    iconClosed: PropTypes.string,
    hoverClosed: PropTypes.string,
    fetching: PropTypes.bool
  };

  static defaultProps = {
    allowMultipleOpen: false,
    opened: false,
    iconLeft: false,
    fetching: false
  };

  constructor(props) {
    super(props);

    const openSections = {};

    //if this.props.children is an array of objects, else it is just a single object
    if (Array.isArray(this.props.children)) {
      this.props.children &&
        this.props.children.forEach((child) => {
          if (child && child.props.isOpen) {
            openSections[child.props.label] = true;
          }
        });
    } else {
      if (this.props.children.props.isOpen) {
        openSections[this.props.children.props.label] = true;
      }
    }

    this.state = { openSections };
  }

  onClick = (label) => {
    const {
      props: { allowMultipleOpen },
      state: { openSections }
    } = this;
    const isOpen = !!openSections[label];

    if (allowMultipleOpen) {
      this.setState({
        openSections: {
          ...openSections,
          [label]: !isOpen
        }
      });
    } else {
      this.setState({
        openSections: {
          [label]: !isOpen
        }
      });
    }
  };

  render() {
    const {
      onClick,
      props: { children, resizeModal, opened, iconLeft, iconOpened, hoverOpened, iconClosed, hoverClosed, fetching },
      state: { openSections }
    } = this;

    return (
      <div className="accordionsContainer" key={this.props.keyId}>
        {Array.isArray(children)
          ? children.map(
              (child, idx) =>
                child && (
                  <AccordionSection
                    key={idx}
                    keyId={idx}
                    isOpen={opened ? !openSections[child.props.label] : !!openSections[child.props.label]}
                    label={child.props.label}
                    // checkbox={child.props.checkbox === false ? false : true}
                    onClick={onClick}
                    resizeModal={resizeModal}
                    iconLeft={iconLeft}
                    iconOpened={iconOpened}
                    hoverOpened={hoverOpened}
                    iconClosed={iconClosed}
                    hoverClosed={hoverClosed}
                    fetching={fetching}
                  >
                    {child.props.children}
                  </AccordionSection>
                )
            )
          : children && (
              <AccordionSection
                keyId={children.props.keyId}
                isOpen={opened ? !openSections[children.props.label] : !!openSections[children.props.label]}
                label={children.props.label}
                // checkbox={children.props.checkbox === false ? false : true}
                onClick={onClick}
                resizeModal={resizeModal}
                iconLeft={iconLeft}
                iconOpened={iconOpened}
                hoverOpened={hoverOpened}
                iconClosed={iconClosed}
                hoverClosed={hoverClosed}
                fetching={fetching}
              >
                {children.props.children}
              </AccordionSection>
            )}
      </div>
    );
  }
}
